import React, { useEffect } from 'react';

const SITE_NAME = 'GuyRules';
const DEFAULT_DESCRIPTION = 'Etiquette, rules, and humor about guys—wife, tools, family, dating, sports, and life. Browse and vote on Guy Rules.';
const DEFAULT_IMAGE = '/images/guyrules_header.png';

/**
 * Sets document title and meta tags for SEO and sharing (Open Graph, Twitter).
 * Optional: pass jsonLd (object or array) for structured data.
 */
function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath,
  image = DEFAULT_IMAGE,
  noIndex = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = canonicalPath
    ? `${window.location.origin}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`
    : window.location.href;
  const imageUrl = image.startsWith('http') ? image : `${window.location.origin}${image.startsWith('/') ? image : `/${image}`}`;

  useEffect(() => {
    document.title = fullTitle;

    // JSON-LD structured data
    const existing = document.getElementById('seo-jsonld');
    if (existing) existing.remove();
    if (jsonLd && typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.id = 'seo-jsonld';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(Array.isArray(jsonLd) ? jsonLd : jsonLd);
      document.head.appendChild(script);
    }

    const setMeta = (attr, key, value) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    setMeta('name', 'description', desc);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', imageUrl);
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', canonicalUrl);

    if (noIndex) {
      setMeta('name', 'robots', 'noindex,nofollow');
    } else {
      setMeta('name', 'robots', 'index,follow');
    }
  }, [fullTitle, desc, canonicalUrl, imageUrl, noIndex, jsonLd]);

  return null;
}

export default SEO;
